import * as Actions from '../../actions';

const initialState = { data: null };

const listCloseDayDetails = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_CLOSE_DAY_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listCloseDayDetails;
